import { createApiCall } from 'lib/base';

const FETCH_INVESTCORE_USER_IDENTIFICATION_DETAIL_API_ID =
  'DASHBOARD/FETCH_INVESTCORE_USER_IDENTIFICATION_DETAIL_API';

const apiCall = createApiCall(
  FETCH_INVESTCORE_USER_IDENTIFICATION_DETAIL_API_ID,
  ({ id }) => ({
    endpoint: `/api/admin/users/identifications/${id}`,
    method: 'GET',
  })
);

export default apiCall;
